import { notificationContainer } from 'untils/notificationContainer';

// ==========================================:
const customResponseErrors = (errorMessage: string, type: string, response: any) => {
  const urlPath = response.config.url;

  const params: string = urlPath?.split('/').pop()?.replace('_', '/').toUpperCase() || ' ';
  if (errorMessage === 'Pair_not_available') {
    notificationContainer(`Pair ${params}  not available. Choose another pair.`, type);
  } else {
    notificationContainer(errorMessage, type);
  }
};
export { customResponseErrors };
